interface Items {
  item_id: string;
  quantity: number;
  price?: number;
  item_variant: string;
  item_name: string;
}
interface PurchaceCall {
  transaction_id: string;
  value: number;
  items: any;
  affiliation?: string;
  name: string;
  id: string;
  currency: string;
}
interface AddCart {
  value: number;
  items: any;
  affiliation?: string;
  name: string;
  id: string;
}
interface ViewItem {
  item_id: string;
  item_name: string;
  item_price: string;
  currency_code: string;
}
interface CARD extends ViewItem {
  quantity: number;
}
const googleAnalyticsTransaction = async (data: PurchaceCall) => {
  const { items, name, id,currency, ...rest } = data;
  if(!id){
    return
  }
  const googleAnalyticsItems = <Items[]>[];

  items.map((ageGroup: any) => {
    if (ageGroup.count > 0) {
      googleAnalyticsItems.push({
        item_id: id,
        item_name: name,
        item_variant: ageGroup.title,
        price: Number(ageGroup.price.split('$')[1]),
        quantity: ageGroup.count
      });
    }
  });
  //@ts-ignore
  // @ts-ignore
  if (window?.dataLayer) {
    //@ts-ignore
   console.log('window.dataLayer', window.dataLayer);
  //@ts-ignore
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        currency,
        items: googleAnalyticsItems,
        ...rest
      }
    })
    
  } else {
    console.error('gtag function is not available');
  }
  if (window !== undefined) {
    // @ts-ignore
    await window.fbq('track', 'Purchase', {
      currency,
      value: rest.value
    });
  } else {
    console.error('fbq function is not available');
  }
};

export const view_item = async (data: ViewItem) => {
  if (
    typeof window !== 'undefined' &&
    window.gtag &&
    typeof window.gtag === 'function'
  ) {
    await window.gtag('event', 'view_item', {
      ...data
    });
  } else {
    console.error('gtag function is not available');
  }
};

export const add_to_cart = async (data: CARD) => {
  if (
    typeof window !== 'undefined' &&
    window.gtag &&
    typeof window.gtag === 'function'
  ) {
    await window.gtag('event', 'add_to_cart', {
      ...data
    });
  } else {
    console.error('gtag function is not available');
  }
};
export const googleAnalyticsAddtoCart = async (
  data: AddCart,
  event: string
) => {
  const { items, name, id, ...rest } = data;
  const googleAnalyticsItems = <Items[]>[];

  items.map((ageGroup: any) => {
    if (ageGroup.count > 0) {
      googleAnalyticsItems.push({
        item_id: id,
        item_name: name,
        item_variant: ageGroup.title,
        price: Number(ageGroup.price.split('$')[1]),
        quantity: ageGroup.count
      });
    }
  });
  //@ts-ignore
  // @ts-ignore
  const res =
    window !== undefined && typeof window.gtag === 'function'
      ? await window.gtag('event', event, {
          ...rest,
          currency: 'USD',
          items: googleAnalyticsItems
        })
      : console.error('gtag function is not available');

  if (window !== undefined) {
    // @ts-ignore
    await window.fbq('track', 'Purchase', {
      currency: 'USD',
      value: rest.value
    });
  } else {
    console.error('fbq function is not available');
  }
};
export default googleAnalyticsTransaction;
